import { render, staticRenderFns } from "./HowItWorks.vue?vue&type=template&id=4a440442&scoped=true&"
import script from "./HowItWorks.vue?vue&type=script&lang=true&"
export * from "./HowItWorks.vue?vue&type=script&lang=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a440442",
  null
  
)

export default component.exports